import React from "react";
import { GraficoDeBarras } from "../Echarts";
import {
  CBORankingSes,
  CBORankingSesContainer,
  CBORankingSesCard,
  CBORankingSesCardHeader,
  CBORankingSesCardGraphContainer,
} from "./styles";
import { CircularProgress } from "@material-ui/core";
import { ExceptionText } from "../AreaChartSession/styles";
import { useAxios } from "../../../../../hooks/useAxios";

export function CBORankingSession({ queryState }) {
  let uri = `/casos_por_ocupacao/?uf=${queryState}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <>
      <CBORankingSes>
        <CBORankingSesContainer>
          {loading ? (
            <CBORankingSesCard>
              <CircularProgress color="primary" />
            </CBORankingSesCard>
          ) : (
            <>
              {(error || response?.dados.length === 0) && (
                <CBORankingSesCard>
                  <ExceptionText>
                    Não vai ser possível mostrar o ranking. {error}
                  </ExceptionText>
                </CBORankingSesCard>
              )}
              {response && response.dados.length > 0 && (
                <CBORankingSesCard>
                  <CBORankingSesCardHeader>
                    Profissionais mais afetados pela covid-19 (casos
                    confirmados)
                  </CBORankingSesCardHeader>
                  <CBORankingSesCardGraphContainer>
                    <GraficoDeBarras data={response} />
                  </CBORankingSesCardGraphContainer>
                </CBORankingSesCard>
              )}
            </>
          )}
        </CBORankingSesContainer>
      </CBORankingSes>
    </>
  );
}
